import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, ReplaySubject } from 'rxjs';
import { takeWhile, withLatestFrom } from 'rxjs/operators';
import { AppComponent } from '../app.component';
import * as fromSettings from '../company-setting';
import { CompanySetting } from '../company-setting';
import { Category } from '../shared/category/category.model';
import { LoggingService } from '../shared/services/logging/logging.service';
import { CategoryService } from '../shared/services/category.service';
import * as fromUser2 from '../user-info';
import { IUserInfo } from '../user-info';
import * as fromUser from '../user-info/store/user.reducer';
import * as fromUserInfo from '../user-info/store/user.reducer';
import * as fromUserSetting from '../user-setting/store';

@Component({
    selector: 'ef-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    standalone: false
})
export class MainComponent implements OnInit, OnDestroy {
    public mainResponse: fromUser.IUserAccess;
    public userInfo$: Observable<fromUser2.IUserInfo>;
    public companySettings$: Observable<CompanySetting[]>;
    public companySettings: CompanySetting[];

    dialogCheckboxChangeSubject: ReplaySubject<any> = new ReplaySubject(1);
    onHideMsgDialogSubject: ReplaySubject<any> = new ReplaySubject(1);
    userSettings$: Observable<Array<fromUserSetting.UserSetting>>;

    active = true;
    showMsg: boolean;
    showAdminMsg: boolean;
    adminMsg1: string;
    adminLink1: string;
    showMgrMsg: boolean;
    mgrMsg1: string;
    mgrLink1: string;
    showUserMsg: boolean;
    userMsg1: string;
    userLink1: string;
    showMsgDialog: boolean;
    userInfo: IUserInfo;
    defaultRoleID: number;

    // Get filtered categories from the service
    filteredCategories$ = this.categoryService.filteredCategories$;

    constructor(
        private store: Store<fromUserInfo.State>,
        @Inject(LoggingService) private log: LoggingService,
        private app: AppComponent,
        private categoryService: CategoryService
    ) {}

    ngOnInit() {
        this.active = true;
        this.store.dispatch(
            fromSettings.getCompanySetting({
                SettingType: 'UserMsg1'
            })
        );
        this.setupObservables();
        this.setupSubscriptions();
    }

    ngOnDestroy() {
        this.active = false;
    }

    setupObservables() {
        this.userSettings$ = this.store.pipe(select(fromUserSetting.selectAll));
        this.userInfo$ = this.store.pipe(select(fromUser.getUserInfo));
        this.companySettings$ = this.store.pipe(select(fromSettings.selectAll));
    }

    setupSubscriptions() {
        this.userInfo$
            .pipe(takeWhile(() => this.active))
            .subscribe(userInfo => {
                this.userInfo = userInfo;
                this.defaultRoleID = userInfo.DefaultRoleGroupID;
            });
        // Keep your existing subscription logic for dialogs, user settings, etc.
        this.dialogCheckboxChangeSubject
            .pipe(
                takeWhile(() => this.active),
                withLatestFrom(this.userInfo$)
            )
            .subscribe(([, userInfo]) => {
                this.store.dispatch(
                    fromUserSetting.putUserSettings({
                        settings: [
                            {
                                EmployeeListID: userInfo.EmployeeListID,
                                EmpSettingID: 31.0,
                                EmpSettingType: 'ShowUserMsg',
                                EmpSettingTypeLabel: 'Show User Message',
                                EmpSettingValue: !this.showMsg,
                                CtrlType: 'CheckBox',
                                CatID: 1,
                                CatDescription: 'User Setting'
                            }
                        ]
                    })
                );
            });

        this.onHideMsgDialogSubject
            .pipe(
                takeWhile(() => this.active),
                withLatestFrom(this.userInfo$, this.categoryService.categories$)
            )
            .subscribe(([, userInfo, categories]) => {
                this.showMsgDialog = false;
                this.showAdminMsg = false;
                this.showMgrMsg = false;
                this.showUserMsg = false;
                this.showMsg = null;

                if (userInfo.DefaultRoleGroupID == 12024) {
                } else if (userInfo.DefaultRoleGroupID == 12025) {
                } else if (userInfo.DefaultRoleGroupID == 1) {
                } else {
                    let timecardProcess;
                    categories.forEach(category => {
                        category.UserProcesses.forEach(process => {
                            if (process.RouteName == 'timecard.entry') {
                                timecardProcess = process;
                            }
                        });
                    });
                    this.app.goto(timecardProcess);
                }
            });
    }
}
